import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_amount_content = _resolveComponent("amount-content")!
  const _component_duration_content = _resolveComponent("duration-content")!
  const _component_pvd3_modal = _resolveComponent("pvd3-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_pvd3_modal, {
      id: "modal-container",
      ref: "modalContainer",
      "pvd-z-index": "9999999",
      "pvd-aria-label": "guided-search-modal"
    }, {
      default: _withCtx(() => [
        (_ctx.showAmountContent)
          ? (_openBlock(), _createBlock(_component_amount_content, {
              key: 0,
              id: "amount-modal",
              ref: "amountModal",
              amountValue: _ctx.amountValue,
              amountInvalid: _ctx.amountInvalid,
              amountMaxExceeded: _ctx.amountMaxExceeded,
              onAmountChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.amountChanged($event))),
              onCloseAmountModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchContent()))
            }, null, 8, ["amountValue", "amountInvalid", "amountMaxExceeded"]))
          : _createCommentVNode("", true),
        (_ctx.showDurationContent)
          ? (_openBlock(), _createBlock(_component_duration_content, {
              key: 1,
              id: "duration-modal",
              sliderIndex: _ctx.currentIndex,
              onCloseDurationModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeDurationModal())),
              onBackButtonClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.backButtonClicked())),
              onDurationChanged: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sliderChanged($event)))
            }, null, 8, ["sliderIndex"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512)
  ]))
}